import React, {useCallback, useEffect, useState} from 'react'

import {last} from 'lodash'
import {BreadCrumbsBar} from 'src/components/layout'

import {client} from '@festi/common/api/datocms'
import {breadCrumbsQuery} from '@festi/common/api/datocms/queries'
import {
  BreadCrumbs,
  BreadCrumbsVariables,
} from '@festi/common/api/datocms/types/BreadCrumbs'
import {Page_page} from '@festi/common/api/datocms/types/Page'
import {BreadCrumb} from '@festi/common/utils/categories'

interface Props {
  page: Page_page
}

export default function PageBreadCrumb({page}: Props): JSX.Element {
  const [breadCrumbs, setBreadCrumbs] = useState<BreadCrumb[]>([])

  const path = page.path
  const crumbs = path.split('/')

  const getBreadCrumbs = useCallback(async () => {
    const {data} = await client().query<BreadCrumbs, BreadCrumbsVariables>({
      query: breadCrumbsQuery,
      variables: {
        path: crumbs[1],
      },
    })
    setBreadCrumbs(
      data.allPages
        .filter((p) => path.includes(p.path))
        .sort((a, b) => a.path.length - b.path.length)
        .map((p) => ({path: p.path, label: p.heading})),
    )
  }, [path, crumbs])

  useEffect(() => {
    if (page.path !== last(breadCrumbs)?.path) {
      getBreadCrumbs()
    }
  }, [page.path, breadCrumbs, getBreadCrumbs])

  return <BreadCrumbsBar breadCrumbs={breadCrumbs} />
}
